import { useState, useEffect, useCallback } from 'react';

import { useContractKit } from '@celo-tools/use-contractkit';


const useContract = (abi, contractAddress) => {

    const { getConnectedKit, address } = useContractKit();

    const [contract, setContract] = useState(null);

    const getContract = useCallback(async () => {

        const kit = await getConnectedKit();

        setContract(new kit.web3.eth.Contract(abi, contractAddress));

    }, [getConnectedKit, abi, contractAddress]);

    useEffect(() => {

        if (address) getContract();

    }, [address, getContract]);

    return contract

}

export default useContract